import { render, staticRenderFns } from "./StudioLessonQuizCard.vue?vue&type=template&id=e52266a6&scoped=true&"
import script from "./StudioLessonQuizCard.vue?vue&type=script&lang=js&"
export * from "./StudioLessonQuizCard.vue?vue&type=script&lang=js&"
import style0 from "./StudioLessonQuizCard.vue?vue&type=style&index=0&id=e52266a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52266a6",
  null
  
)

export default component.exports